import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StepPreITE from "./Step1/StepPreITE"; // Assurez-vous d'importer correctement le nouveau composant StepPre
import StepOneITE from "./Step1/StepOneITE";
import StepTwoITE from "./Step1/StepTwoITE";
import StepThreeITE from "./Step1/StepThreeITE";
import StepFourITE from "./Step1/StepFourITE";

const MultiStepFormITE = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0); // Commence avec l'étape préliminaire à l'index 0

  const handleNext = () => {
    if (currentStep === 4) { // Mettez à jour l'index pour la dernière étape après l'ajout de StepPre
      navigate("/client-audit-ite"); // Naviguez après la dernière étape
    } else {
      setCurrentStep((prev) => prev + 1); // Avance à l'étape suivante
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1); // Retour à l'étape précédente
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <StepPreITE onNext={handleNext} />; // Ajoutez le nouveau composant StepPre comme première étape
      case 1:
        return <StepOneITE onNext={handleNext} onBack={handleBack} />;
      case 2:
        return <StepTwoITE onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <StepThreeITE onNext={handleNext} onBack={handleBack} />;
      case 4:
        return <StepFourITE onNext={handleNext} onBack={handleBack} />;
      default:
        return <div>Étape inconnue</div>;
    }
  };

  return (
    <div>
      {renderStep()}
    </div>
  );
};

export default MultiStepFormITE;